/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-require-imports */
import {useFocusEffect, useNavigation} from '@react-navigation/native';
import {StackNavigationProp} from '@react-navigation/stack';
import React, {useCallback, useMemo, useState} from 'react';
import {Platform, ScrollView, View} from 'react-native';
import {connect} from 'react-redux';
import {MAX_RETRIES, RETRY_DELAY} from '../../../data/constants/paiement';
import {StackParams} from '../../../data/types/navigation';
import {VoyageServices} from '../../../services/applicatif/voyages';
import mapDispatchToProps from '../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../services/redux/mapStateToProps';
import {HeaderScreen} from '../../components/Header/HeaderScreen';
import {formsStyles} from '../../components/Inputs/formStyles';
import {Loader} from '../../components/Loader';
import ConfirmationModal from '../../components/Modal/ConfirmationModal';
import Popup from '../../components/Modal/Popup/Popup';
import {ListMenuPaiement} from '../../components/Paiement/MenuList';
const iconetelma = require('../../../ressources/images/iconPaiement/mvola.png');
const iconeOrange = require('../../../ressources/images/iconPaiement/orange-money.png');
const iconeAirtel = require('../../../ressources/images/iconPaiement/airtel-money.png');
const iconeVisa = require('../../../ressources/images/iconPaiement/visa.png');
const iconeComptant = require('../../../ressources/images/iconPaiement/comptant.png');

type NavigationProps = StackNavigationProp<StackParams, 'MesSinistres'>;

export function PayementScreen() {
  const {navigate} = useNavigation<NavigationProps>();
  const [isVisa, setIsVisa] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isVisaUnavailableFormVisible, setIsVisaUnavailableFormVisible] =
    useState(false);
  const {getStatusPayment} = VoyageServices();
  const [currentStatus, setCurrentStatus] = useState<Array<any>>([]);

  const AirtelPayment = useCallback(() => {
    const status = currentStatus.find(
      (element: any) => element.name === 'airtel',
    );

    status?.isActive
      ? navigate('AirtelPayment')
      : navigate('NewFeatures', {
          text: status?.messageOnDisable,
          type: 'airtel',
        });
  }, [currentStatus]);

  const OrangePayment = useCallback(() => {
    const status = currentStatus.find(
      (element: any) => element.name === 'orange',
    );

    status?.isActive
      ? navigate('OrangePayment')
      : navigate('NewFeatures', {
          text: status?.messageOnDisable,
          type: 'orange',
        });
  }, [currentStatus]);

  const TelmaPayment = useCallback(() => {
    const status = currentStatus.find(
      (element: any) => element.name === 'telma',
    );

    status?.isActive
      ? navigate('TelmaPayment')
      : navigate('NewFeatures', {
          text: status?.messageOnDisable,
          type: 'telma',
        });
  }, [currentStatus]);

  const VisaPayement = useCallback(() => {
    const status = currentStatus.find(
      (element: any) => element.name === 'bank',
    );

    status?.isActive
      ? navigate('CbPayment')
      : navigate('NewFeatures', {text: status?.messageOnDisable, type: 'bank'});
  }, [currentStatus]);

  const ComptantPayment = useCallback(() => {
    const status = currentStatus.find(
      (element: any) => element.name === 'comptant',
    );

    status?.isActive
      ? navigate('ComptantPayment')
      : navigate('NewFeatures', {
          text: status?.messageOnDisable,
          type: 'comptant',
        });
  }, [currentStatus]);

  const menuList = useMemo(
    () => [
      {
        title: 'Telma',
        source: iconetelma,
        handleMove: TelmaPayment,
      },
      {
        title: 'Orange',
        source: iconeOrange,
        handleMove: OrangePayment,
      },
      {
        title: 'Airtel',
        source: iconeAirtel,
        handleMove: AirtelPayment,
      },
      {
        title: 'Visa',
        source: iconeVisa,
        handleMove: VisaPayement,
      },
      {
        title: 'Comptant',
        source: iconeComptant,
        handleMove: ComptantPayment,
      },
    ],
    [currentStatus],
  );

  // Function to fetch payment status with retry logic
  const fetchStatusWithRetry = async (retries: number = MAX_RETRIES) => {
    try {
      setLoading(true);
      const res = await getStatusPayment();
      if (res?.data?.items) {
        console.log('fetched status', res.data);

        setCurrentStatus(res.data.items);
      }
      setLoading(false);
    } catch {
      if (retries > 0) {
        console.log(`Retrying... (${MAX_RETRIES - retries + 1})`);
        setTimeout(() => fetchStatusWithRetry(retries - 1), RETRY_DELAY);
      } else {
        console.log('Max retries reached, giving up.');
        setLoading(false);
      }
    }
  };

  useFocusEffect(
    React.useCallback(() => {
      fetchStatusWithRetry(); // Start fetching with retries
    }, []),
  );

  return (
    <View style={{flex: 1}}>
      <HeaderScreen
        title="Paiement"
        type="GoToMonEspace"
        noBreadcrumb={false}
      />
      {loading ? (
        <Loader />
      ) : (
        <ScrollView>
          <View style={[formsStyles.webformContain]}>
            <View
              style={[
                formsStyles.formContainPayment,
                Platform.OS === 'web'
                  ? formsStyles.paymentContainWeb
                  : formsStyles.paymentContain,
              ]}>
              {isVisa && (
                <ConfirmationModal
                  title="Paiement par carte bancaire"
                  content="Le paiement sera disponible bientôt"
                  btn1="OK"
                  handleBtn1={() => setIsVisa(false)}
                />
              )}
              <ListMenuPaiement data={menuList} isHome={false} />
              {isVisaUnavailableFormVisible && (
                <Popup
                  title="Indisponible"
                  content="Ce service est momentanément indisponible."
                  exit={() => setIsVisaUnavailableFormVisible(false)}
                />
              )}
            </View>
          </View>
        </ScrollView>
      )}
    </View>
  );
}
export const Payement: any = connect(
  mapStateToProps,
  mapDispatchToProps,
)(PayementScreen);
